import { useContext, useEffect, useState } from 'react';
import {
  CertMasterAuthenticateModal,
  LinkedSuccessfullyModal,
  MissingProductsModal,
} from 'components';
import { CertMasterPlatformLinkAccountContext } from './CertMasterPlatformLinkAccountContext';

export function CertMasterPlatformLinkAccount({
  refreshEntitlements,
}: {
  refreshEntitlements: () => void;
}) {
  const context = useContext(CertMasterPlatformLinkAccountContext);
  const [showMissingProductsModal, setShowMissingProductsModal] =
    useState(false);
  const [showAuthenticate, setShowAuthenticate] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    setShowMissingProductsModal(!!context?.isLinking);
  }, [context?.isLinking]);

  return (
    <>
      <MissingProductsModal
        isOpen={showMissingProductsModal}
        onClose={() => {
          setShowMissingProductsModal(false);
          context?.setIsLinking(false);
        }}
        onLinkAccount={() => {
          setShowAuthenticate(true);
          setShowMissingProductsModal(false);
        }}
      />
      <CertMasterAuthenticateModal
        onBackClicked={() => {
          setShowAuthenticate(false);
          setShowMissingProductsModal(true);
        }}
        onClose={() => {
          setShowAuthenticate(false);
          context?.setIsLinking(false);
        }}
        isShowing={showAuthenticate}
        onLinked={() => {
          setShowSuccess(true);
          refreshEntitlements();
          setShowAuthenticate(false);
        }}
      />
      <LinkedSuccessfullyModal
        isOpen={showSuccess}
        onClose={() => {
          setShowSuccess(false);
          context?.setIsLinking(false);
        }}
      />
    </>
  );
}
